import axios from "axios";
import { baseUrl } from "../utils/constants";

// Get Side Module  //
export const getModuleApi = async (userToken) => {
  return new Promise(async (resolve, reject) => {
    const url = `${baseUrl}/contractor/modules`;
    
    try {
     
      let response = await axios.get(url, {
        headers: {
          Authorization: userToken,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });
      resolve(response?.data);
    } catch (error) {
      console.log("api error::", error?.response?.data);
      reject(error.response?.data);
    }
  });
};
